import { useQuery } from '@tanstack/react-query';
import type { AgentApiProvidedJobPostTagsIndex } from '@/types/serializers';

export const PROVIDED_JOB_POST_TAGS_QUERY_KEY = '/agent/api/provided_job_post_tags';

export default function useProvidedJobPostTags() {
  return useQuery({
    queryKey: [PROVIDED_JOB_POST_TAGS_QUERY_KEY],
    queryFn: async () => {
      const response = await fetch('/agent/api/provided_job_post_tags.json');
      const data: AgentApiProvidedJobPostTagsIndex = await response.json();
      return data;
    },
    select: (data) => ({
      tags: data.records.map(({ id, name, color_hex }) => ({ id, name, colorHex: color_hex })),
    }),
  });
}
